export default "__VITE_ASSET__6x_hRgI0__"